import { Table, Pagination, Button, Popconfirm } from "antd";
import moment from "moment";
function DataTable(props) {
  const columns = [
    {
      title: "#",
      key: "index",
      width: "20px",
      //  fixed: 'left',
      render: (text, record, index) =>
        (props.meta.page - 1) * props.meta.take + index + 1,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => <div>{date && moment(date).format("DD-MM-YYYY")}</div>,
    },
    { title: "Head", dataIndex: "head", key: "head" },
    {
      title: "User",
      dataIndex: "userid",
      key: "userid",
      render: (text, record) => (
        <div>{record.expance_user && record.expance_user.name}</div>
      ),
    },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    // {
    //   title: "",
    //   render: (item) => (
    //     <div className="tableAction">
    //       <Popconfirm
    //         placement="bottomRight"
    //         title={"Are you sure to delete?"}
    //         okText="Yes"
    //         cancelText="No"
    //         onConfirm={() => props.delete(item)}
    //       >
    //         <Button size="small">Delete</Button>
    //       </Popconfirm>
    //       {/* <Button
    //         size="small"
    //         onClick={() => props.update(item)}
    //         type="primary"
    //       >
    //         Edit
    //       </Button> */}
    //     </div>
    //   ),
    // },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={false}
        size="small"
      />
      <div align="right">
        <Pagination
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}

export default DataTable;
